export default __webpack_public_path__ + "38e1b3b.png";